import { useContext } from "react";
import { ReportPdfContext } from "src/utils/contexts";

// Render media component by type
export const GetMediaComponent = ({ vidSrc, audioSrc, imgSrc, audioSrcLabel }) => {
	const { reportPdfView } = useContext(ReportPdfContext) || {}

	// Players are meaningless in a PDF, and <source> inside <audio>/<video> has no
	// computed style, which crashes html2canvas. Show a plain label instead.
	const renderAudio = () => {
		if (reportPdfView) {
			return <span className="semibold">{audioSrcLabel ? `${audioSrcLabel}: audio attached` : "Audio attached"}</span>
		}
		return (
			<>
				{
					audioSrcLabel &&
					<span className="semibold mr-20">{audioSrcLabel}</span>
				}
				<audio controls width="100%">
					<source src={audioSrc} type="audio/mpeg" />
				</audio>
			</>
		)
	}

	const renderVideo = () => {
		if (reportPdfView) {
			return <span className="semibold">Video attached</span>
		}
		return (
			<video controls width="100%" style={{ maxWidth: "400px" }}>
				<source src={vidSrc} />
			</video>
		)
	}

	return (
		<>
			{
				audioSrc &&
				<div className="flex items-center mt-20">
					{renderAudio()}
				</div>
			}
			{
				imgSrc &&
				<div className="flex items-center my-20">
					<img src={imgSrc} width={"200px"} />
				</div>
			}
			{
				vidSrc &&
				<div className="flex items-center my-20">
					{renderVideo()}
				</div>
			}
		</>
	)
}
